import React from 'react';
import CharacterCardFragment2 from "../parts/CharacterCardFragment2";
import {useTranslation} from "react-i18next";
import './ArticleCard.css'

function ArticleCard(props){
    const article = props.article || [];
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language || 'it';

    function toDate(timeInMillis){
        const date = new Date(parseInt(timeInMillis));
        return date.toLocaleDateString(currentLang, {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    }

    return (<>
        <div key={article.id}
             className="card-bg rounded-2xl shadow-2xl transform hover:-translate-y-2 transition duration-500 ease-in-out">
            <CharacterCardFragment2 characters={article.characters} />
            <div className="overflow-hidden rounded-2xl">
            <div className="relative">
                <img
                    src={`/data/json/article/img/${article.id}.png`}
                    alt={article.title}
                    className="w-full h-80 object-cover"
                />

                <div className="absolute bottom-0 card-title" style={{
                    backdropFilter: "blur(12px)",
                    background: "rgba(0,0,0,0.25)",
                }}>
                    <h3 className="p-4 text-lg font-bold relative z-10 article-title-home">{article.title}</h3>
                    <div className="absolute bottom-1 right-1 w-full flex justify-end" >
                        <span className="text-[#cccccc] text-xs articleDate">{toDate(article.id)}</span>
                    </div>
                </div>
            </div>

            <div className="relative add-card-bg"  >

                <div className="p-6 relative">
                    <p className="text-gray-300 mb-4">{article.subtitle}</p>

                </div>
                <div className="relative" style={{height: "1rem"}}>

                </div>


            </div>
            <div className="p-6 absolute bottom-0 w-full">
                <a className="font-semibold text-[#00aaaa]  hover:text-[#00eeee] flex items-center group"
                   href={`/${currentLang}/article/${article.url}`}>
                    {t('general.readMore')}
                    <span
                        className="material-icons ml-2 transform group-hover:translate-x-1 transition-transform duration-300">arrow_forward</span>
                </a>
            </div>

        </div>
        </div>
        </>);
}

export default ArticleCard;